/* Virtual Games · desplegable de opciones del bloque de compra 5C (Matías, 7-oct-2026).
   Los radios de Horizon siguen siendo la fuente: al elegir se marca el radio y se dispara change, así
   Horizon cambia la variante y vg-variant-combos corrige combinaciones que no existen.
   Todo va por delegación en document, así funciona también en el modal del carrito rápido y después de
   que Horizon vuelve a dibujar el selector. Teclado: flechas, Inicio, Fin, Enter, Espacio, Esc y Tab.
   En celular la lista sale como panel inferior. */
(function () {
  if (window.vgDd) return;
  window.vgDd = true;
  var abierto = null;
  var hoja = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  function opciones(dd) { return Array.prototype.slice.call(dd.querySelectorAll('[role="option"]')); }

  function activar(dd, op) {
    var lista = dd.querySelector('[role="listbox"]');
    opciones(dd).forEach(function (o) { o.classList.toggle('is-act', o === op); });
    if (!op) return;
    lista.setAttribute('aria-activedescendant', op.id);
    op.scrollIntoView({ block: 'nearest' });
  }

  function abrir(dd) {
    if (abierto && abierto !== dd) cerrar(abierto, false);
    var btn = dd.querySelector('.vg-dd__btn');
    var esHoja = !!(hoja && hoja.matches);
    dd.querySelector('.vg-dd__pop').hidden = false;
    dd.querySelector('.vg-dd__bg').hidden = !esHoja;
    btn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.toggle('vg-dd-hoja', esHoja);
    abierto = dd;
    var lista = dd.querySelector('[role="listbox"]');
    lista.focus({ preventScroll: true });
    activar(dd, dd.querySelector('[aria-selected="true"]') || opciones(dd)[0]);
  }

  function cerrar(dd, devolverFoco) {
    var btn = dd.querySelector('.vg-dd__btn');
    dd.querySelector('.vg-dd__pop').hidden = true;
    dd.querySelector('.vg-dd__bg').hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('vg-dd-hoja');
    if (abierto === dd) abierto = null;
    if (devolverFoco && btn) btn.focus({ preventScroll: true });
  }

  function elegir(dd, op) {
    var fs = dd.closest('fieldset');
    var radio = null;
    if (fs) {
      fs.querySelectorAll('input[type="radio"]').forEach(function (i) { if (i.value === op.dataset.value) radio = i; });
    }
    cerrar(dd, true);
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var btn = t.closest('.vg-dd__btn');
    if (btn) {
      var dd = btn.closest('.vg-dd');
      if (btn.getAttribute('aria-expanded') === 'true') cerrar(dd, false); else abrir(dd);
      return;
    }
    var op = t.closest('.vg-dd [role="option"]');
    if (op) { elegir(op.closest('.vg-dd'), op); return; }
    if (t.closest('.vg-dd__x') || t.closest('.vg-dd__bg')) { cerrar(t.closest('.vg-dd'), true); return; }
    if (abierto && !abierto.contains(t)) cerrar(abierto, false);
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var dd = t.closest('.vg-dd');
    if (!dd) return;
    if (t.classList.contains('vg-dd__btn') && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      e.preventDefault();
      abrir(dd);
      return;
    }
    if (t.getAttribute('role') !== 'listbox') {
      if (e.key === 'Escape' && abierto === dd) { e.preventDefault(); cerrar(dd, true); }
      return;
    }
    var L = opciones(dd);
    var i = L.indexOf(dd.querySelector('.is-act'));
    if (e.key === 'ArrowDown') { e.preventDefault(); activar(dd, L[Math.min(L.length - 1, i + 1)]); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); activar(dd, L[Math.max(0, i - 1)]); }
    else if (e.key === 'Home') { e.preventDefault(); activar(dd, L[0]); }
    else if (e.key === 'End') { e.preventDefault(); activar(dd, L[L.length - 1]); }
    else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (L[i]) elegir(dd, L[i]); }
    else if (e.key === 'Escape') { e.preventDefault(); cerrar(dd, true); }
    else if (e.key === 'Tab') { cerrar(dd, false); }
  });
})();
